import React from "react";

import Nav from "../components/NavigateComponent/Navigate";
import PageNotFound from "../components/PageNotFound/PageNotFound";
import EditProfilePage from "../screens/editProfile/EditProfile";
import MicroSites from "../screens/home/MicroSites";
import FeedBackPage from "../screens/login/Feedback";
import HelpPage from "../screens/login/Help";
import LoginPage from "../screens/login/LoginPage";
import NewMicrosite from "../screens/microsites/newUx/NewMicrosite";
import NewMicrositeDetails from "../screens/microsites/newUx/NewMicrositeDetails";
import OnboardingPage from "../screens/onboarding/OrgOnboarding";
import TermsPage from "../screens/onboarding/terms";
import OtpPage from "../screens/otp/OtpPage";
import PartnerPage from "../screens/partnerScreen/PartnerPage";

const publicRoutes = [
  {
    path: "login",
    component: <LoginPage />,
  },
  {
    path: "help",
    component: <HelpPage />,
  },
  {
    path: "feedback",
    component: <FeedBackPage />,
  },
  {
    path: "verifyOtp",
    component: <OtpPage />,
  },
  {
    path: "frontend/:partner",
    component: <PartnerPage />,
  },
  {
    path: "home",
    component: <MicroSites />,
  },
  {
    path: "edit",
    component: <EditProfilePage />,
  },

  {
    path: "onboarding",
    component: <OnboardingPage />,
  },
  {
    path: "terms",
    component: <TermsPage />,
  },
  {
    path: "",
    component: <Nav />,
  },
  {
    path: "*",
    component: <PageNotFound />,
  },
  {
    path: "microsite",
    component: <MicroSites />,
  },

];

const privateRoutes = [
  {
    path: "microsite/:id",
    component: <NewMicrosite />,
  },
  {
    path: "microsite/:id/micrositeDetails",
    component: <NewMicrositeDetails />,
  },
];

export { privateRoutes, publicRoutes };
